/* istanbul ignore file */
import { forwardRef } from 'react';

import { CreatePrintingProposal } from './CreatePrintingProposal';
import { CreateFourSquareProposal } from './CreateFourSquareProposal';
import type { ProposalFormPayload } from './useProposalForm';

export interface CreateProposalHandle {
    getFormData: () => ProposalFormPayload;
}

type CreateProposalProps = {
    shouldDisableSubmit?: (hasError: boolean) => void;
    setView: (view: 'list' | 'create' | 'edit' | 'preview' | 'none') => void;
    setEditMode?: (isEditMode: boolean) => void;
    isEditMode?: boolean;
    isFourSquare?: boolean;
    isViewMode?: boolean;
};

/**
 * Thin dispatcher that selects the appropriate concrete proposal editor
 * based on the `isFourSquare` flag. Each concrete component owns its own
 * domain (printing vs. 4-square) without runtime branching inside the form.
 */
export const CreateUpdateProposal = forwardRef<CreateProposalHandle, CreateProposalProps>(
    ({ shouldDisableSubmit, setView, isEditMode, setEditMode, isFourSquare, isViewMode }, ref) => {
        if (isFourSquare) {
            return (
                <CreateFourSquareProposal
                    ref={ref}
                    shouldDisableSubmit={shouldDisableSubmit}
                    setView={setView}
                    setEditMode={setEditMode}
                    isEditMode={isEditMode}
                    isViewMode={isViewMode}
                />
            );
        }

        return (
            <CreatePrintingProposal
                ref={ref}
                shouldDisableSubmit={shouldDisableSubmit}
                setView={setView}
                setEditMode={setEditMode}
                isEditMode={isEditMode}
            />
        );
    }
);

CreateUpdateProposal.displayName = 'CreateUpdateProposal';
